// Provides inline rename behaviour for point-cloud labels.
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["display", "form", "input"]

  connect() {
    this.submitting = false
    this.originalValue = this.inputTarget.value
  }

  startEdit() {
    if (this.submitting) {
      return
    }

    this.displayTarget.classList.add("d-none")
    this.formTarget.classList.remove("d-none")
    this.inputTarget.focus()
    this.inputTarget.select()
  }

  startEditFromKeyboard(event) {
    if (event.key !== "Enter" && event.key !== " ") {
      return
    }

    event.preventDefault()
    this.startEdit()
  }

  handleKeydown(event) {
    if (event.key === "Escape") {
      event.preventDefault()
      this.cancelEdit()
      return
    }

    if (event.key === "Enter") {
      event.preventDefault()
      this.submit()
    }
  }

  submitOnBlur() {
    this.submit()
  }

  submit() {
    if (this.submitting) {
      return
    }

    const nextValue = this.inputTarget.value.trim()
    // Cancel when unchanged or empty to avoid unnecessary requests.
    if (nextValue.length === 0 || nextValue === this.originalValue) {
      this.cancelEdit()
      return
    }

    this.inputTarget.value = nextValue
    this.submitting = true
    this.formTarget.requestSubmit()
  }

  onSubmitEnd(event) {
    this.submitting = false

    if (!event.detail.success) {
      this.displayTarget.classList.add("d-none")
      this.formTarget.classList.remove("d-none")
      this.inputTarget.focus()
      return
    }

    this.originalValue = this.inputTarget.value
  }

  cancelEdit() {
    this.inputTarget.value = this.originalValue
    this.formTarget.classList.add("d-none")
    this.displayTarget.classList.remove("d-none")
  }
}
